module.exports = __webpack_public_path__ + "static/media/tyre-green-6.bc9ac381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-green-6.png
// module id = 1144
// module chunks = 0